let config = {
   BASE_URL : `https://apipostman.onlinecu.in/`,
    // BASE_URL : `http://3.7.239.130:8000/`,
    PRODUCTION_URL : `http://172.17.18.255:8080/` ,
}

export default config;
